import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, EmailDecoder, field, RecordDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter } from '@stamhoofd/utility';
export class EmailInformation extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.markedAsSpam = false;
        this.hardBounce = false;
        this.unsubscribedMarketing = false;
        this.unsubscribedAll = false;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], EmailInformation.prototype, "email", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailInformation.prototype, "markedAsSpam", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailInformation.prototype, "hardBounce", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailInformation.prototype, "unsubscribedMarketing", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], EmailInformation.prototype, "unsubscribedAll", void 0);
export class Replacement extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], Replacement.prototype, "token", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Replacement.prototype, "value", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], Replacement.prototype, "html", void 0);
export class Recipient extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.firstName = null;
        this.lastName = null;
        this.replacements = [];
        this.headers = null;
        /**
         * Set this to create a replacement called signInUrl, which will auto sign in/sign up the user
         * Note: the e-mail is matched with the user id, if it doesn't match, the sign-in button will contain a simple (non smart) url
         */
        this.userId = null;
        /// For reference and filtering
        /**
         * @deprecated
         * Use types instead
         */
        this.type = null;
        /// For reference and filtering
        this.types = [];
    }
    merge(recipient) {
        var _a;
        this.firstName = this.firstName !== null && this.firstName.length > 0 ? this.firstName : recipient.firstName;
        this.lastName = this.lastName !== null && this.lastName.length > 0 ? this.lastName : recipient.lastName;
        for (const replacement of recipient.replacements) {
            const existing = this.replacements.find(r => r.token == replacement.token);
            if (!existing) {
                this.replacements.push(replacement);
            }
            else {
                if (existing.value.length == 0) {
                    existing.value = replacement.value;
                }
            }
        }
        this.userId = (_a = this.userId) !== null && _a !== void 0 ? _a : recipient.userId;
        this.types = Formatter.uniqueArray(this.types.concat(recipient.types));
    }
    /**
     * Remove duplicate replacements, keeping the last added replacements
     */
    removeDuplicates() {
        const replacements = [];
        for (const replacement of this.replacements.slice().reverse()) {
            if (!replacements.find(r => r.token === replacement.token)) {
                replacements.unshift(replacement);
            }
        }
        this.replacements = replacements;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Recipient.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 112 })
], Recipient.prototype, "lastName", void 0);
__decorate([
    field({ decoder: EmailDecoder })
], Recipient.prototype, "email", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Replacement) })
], Recipient.prototype, "replacements", void 0);
__decorate([
    field({ decoder: new RecordDecoder(StringDecoder, StringDecoder), version: 209, nullable: true })
], Recipient.prototype, "headers", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 80 })
], Recipient.prototype, "userId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 96 })
], Recipient.prototype, "type", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), optional: true })
], Recipient.prototype, "types", void 0);
export class EmailAttachment extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.filename = null;
        this.contentType = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailAttachment.prototype, "filename", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailAttachment.prototype, "contentType", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailAttachment.prototype, "content", void 0);
export class EmailRequest extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.text = null;
        this.html = null;
        this.attachments = [];
        this.defaultReplacements = [];
    }
}
__decorate([
    field({ decoder: StringDecoder })
], EmailRequest.prototype, "emailId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmailRequest.prototype, "subject", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Recipient) })
], EmailRequest.prototype, "recipients", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailRequest.prototype, "text", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmailRequest.prototype, "html", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(EmailAttachment), version: 11 })
], EmailRequest.prototype, "attachments", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Replacement), version: 220 })
], EmailRequest.prototype, "defaultReplacements", void 0);
//# sourceMappingURL=EmailRequest.js.map